module.exports = __webpack_public_path__ + "static/media/buscar-denuncia.c81015f1.png";